export default __webpack_public_path__ + "static/media/firstcoffee03.481d2715.png";